import React, { createContext, useState, useEffect, useContext } from "react";
import { websocketService } from "../services/websocketService";

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {


	useEffect(() => {

		const websocketUrl = process.env.REACT_APP_WS_URL;
		//當有websocket時再打開
		// websocketService.connect(websocketUrl, (msg) => {
		// 	// console.log("收到 WebSocket 訊息:", msg);

		// 	switch (msg.type) {
		// 		default:
		// 			console.warn("未知的 WebSocket 訊息類型:", msg.type);
		// 			break;
		// 	}
		// });

		// return () => {
		// 	websocketService.disconnect();
		// };
	}, [
		
	]);

	return (
		<GlobalContext.Provider
			value={{
				
			}}
		>
			{children}
		</GlobalContext.Provider>
	);
};
